export const capitalize = str => (
    str.replace(/\b\w/g , m => m.toUpperCase())
);